import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PublicacaoOferta } from 'src/models/interfaces/publicacao/publicacao-interface';
import { PublicacaoService } from '../services/publicacao/publicacao.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'spe-publicacao',
  templateUrl: './publicacao.component.html',
  styleUrls: ['./publicacao.component.scss'],
  standalone: false
})
export class PublicacaoComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  public bannerHtmlString: SafeHtml | undefined;
  private id: string | undefined;
  constructor(
    private appComponent: AppComponent,
    private publicacaoService: PublicacaoService,
    private activatedRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.appComponent.hideHeader = true;

    const queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.id = params.id;
      if (!this.id) {
        return;
      }
      const subscription = this.publicacaoService.getPublicacaoById(Number(this.id)).subscribe({
        next: (publicacao: PublicacaoOferta) => {
          const decodedData = atob(publicacao.materia);

          const finalHtml = ` <!DOCTYPE html>
                            <style media="print">
                                .no-print {
                                display: none;
                              }
                            </style>
                            <html>
                              <body>${decodedData}
                                <button onclick="window.print()" class="no-print">
                                  Imprimir
                                </button>
                              </body>
                            </html>`;
          this.bannerHtmlString = this.domSanitizer.bypassSecurityTrustHtml(finalHtml);
          this.cdr.detectChanges();
        },
        error: () => {
          this.cdr.detectChanges();
        }
      });
      this.subscriptions.push(subscription);
    });
    this.subscriptions.push(queryParamsSubscription);
    setTimeout(() => {
      this.appComponent.hideHeader = true;
    }, 100);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
